import { ReportMetricsResponse } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';

export const reportV2AccessorFn = (columnId: string) => {
  return (data: ReportMetricsResponse | null) =>
    data?.[columnId.toUpperCase()] ?? '';
};
